import warning from 'warning';

var warned = {};

export default function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  warning.apply(undefined, [falseToWarn, message].concat(args));
}

export function _resetWarned() {
  warned = {};
}


//////////////////
// WEBPACK FOOTER
// ./~/react-router/es/routerWarning.js
// module id = 314
// module chunks = 3